/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostAgentGraphPathParams = NonNullable<operations['postAgentGraph']['parameters']['path']>;

export type PostAgentGraphRequestBody = OperationRequestBodyContent<operations['postAgentGraph']>;

export interface Input extends PostAgentGraphPathParams {
  apiVersion?: string;
  body: PostAgentGraphRequestBody;
  header: NonNullable<operations['postAgentGraph']['parameters']['header']>;
}

export async function postAgentGraph(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/agent-graphs', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
